<template>
  <div>
    <div class="box m-5">
      <div class="columns">
        <div class="column is-6">
          <p class="mb-6 has-text-weight-bold">Deposit</p>

          <div class="my-4">
            <p class="has-text-grey is-size-7">User wallet</p>
            <div class="field has-addons mb-1">
              <p class="control is-expanded">
                <input v-model="deposit.userWallet" :readonly="depositType=='cmty token' || isViewAsset" class="input" type="text" />
              </p>
            </div>
          </div>

          <div class="my-4">
            <p class="has-text-grey is-size-7">Amount</p>
            <div class="field has-addons mb-1">
              <p class="control is-expanded">
                <input v-model="deposit.amount" :readonly="isViewAsset" class="input" type="number" />
              </p>
              <p class="control">
                <a class="button is-static"> CMTY </a>
              </p>
            </div>
          </div>

          <div v-if="isMinterUser && !isViewAsset">
            <div class="control">
              <label class="radio has-text-grey is-size-7">
                <input type="radio" value="cmty token" v-model="depositType" />
                CMTY Tokens
              </label>
              <label class="radio has-text-grey is-size-7">
                <input type="radio" value="other" v-model="depositType" />
                Other Assets
              </label>
            </div>
          </div>

          <div v-if="depositType=='other'" class="mt-5">
            <div class="control">
              <p class="mb-1 has-text-grey is-size-7">Name</p>
              <input class="input bg-color-main" v-model="nftName" type="text" />
            </div>

            <div class="control mt-2">
              <p class="mb-1 has-text-grey is-size-7">Description</p>
              <textarea class="textarea bg-color-main" v-model="nftDescription" rows="2"></textarea>
            </div>

            <p class="mt-5 has-text-grey is-size-7">Attributes</p>
            <p v-if="attributeList.length==0" class="has-text-centered is-size-7 has-text-grey mb-3">no attributes added</p>
            <div v-for="(x, index) in attributeList" :key="index" class="columns">
              <div class="column is-flex-grow-5">
                  <div class="control">
                      <p class="mb-1 has-text-grey is-size-7">Name</p>
                      <input class="input bg-color-main" v-model="x.trait_type" type="text" />
                  </div>
              </div>
              <div class="column is-flex-grow-5">
                  <div class="control">
                      <p class="mb-1 has-text-grey is-size-7">Value</p>
                      <input class="input bg-color-main" v-model="x.value" type="text" />
                  </div>
              </div>
              <div class="column mt-auto">
                  <button @click="removeAttribute(index)" class="button is-secondary"><i class="ri-delete-bin-line"></i></button>
              </div>
            </div>

            <div class="has-text-right">
              <button @click="addAttribute()" class="button is-main">Add Attribute</button>
            </div>
            
          </div>

        </div>

        <div class="column is-6 pt-5">
          <div v-if="depositType=='other'">
            <p class="mt-6 has-text-grey is-size-7">Image file</p>
            <div class="file has-name is-fullwidth mt-3">
                <label class="file-label">
                  <input class="file-input" @change="onChangeFileInput($event)" id="nftFile" type="file" name="nftFile" />
                  <span class="file-cta">
                  <span class="file-icon">
                      <i class="fas fa-upload"></i>
                  </span>
                  <span class="file-label"> Choose a file… </span>
                  </span>
                  <span class="file-name has-text-grey"> {{ nftFileName }} </span>
                </label>
            </div>
          </div>

          <div v-if="nftUrlImagePreview != null" class="has-text-centered mt-6">
            <img style="max-height: 450px;" :src="nftUrlImagePreview">
          </div>

          <div class="has-text-centered mt-6">
            <img v-if="nftUrlImagePreview == null" :src="nftMetadata.image">

            <div class="mt-5">
              <a :href="'https://scan.v4.testnet.pulsechain.com/#/token/'+util.NFT_ContractAddress+'/instance/'+this.$route.params.token_id" target="_blank">View on Block Explorer</a>
            </div>
          </div>
        </div>


        <div class="column is-hidden-mobile">
        </div>
      </div>

      <!-- <div v-if="!isViewAsset" class="mt-6"> 
        <button v-if="depositType=='cmty token'" @click="approveToken()" class="button is-dark px-6"> Deposit </button>
        <button v-if="depositType=='other'" @click="mint()" class="button is-dark px-6"> Deposit </button>
      </div> -->
      <div v-if="isViewAsset && isUriSetterUser" class="mt-6">
        <button @click="update()" class="button is-dark px-6"> Update </button>
      </div>
    </div>

    <!-- <div v-if="!isViewAsset" class="box m-5">
      <div class="columns">
        <div class="column">
          <p class="mb-6 has-text-weight-bold">Deposit history</p>
          <vue-countdown class="has-text-danger" v-if="counting" :time="60000" @end="onCountdownEnd" v-slot="{ totalSeconds }">The page will refresh automatically in <strong>{{ totalSeconds }}</strong> seconds</vue-countdown>
          <table class="table is-striped table is-hoverable is-fullwidth">
            <thead>
              <tr>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="x in depositList">
                <td>{{ x.amount }} <span class="has-text-weight-bold has-text-grey is-size-7">CMTY</span></td>
                <td>{{ x.finished }}</td>
              </tr>

              <tr v-if="depositList.length == 0">
                <td colspan="2">There are no transactions yet</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div> -->


  </div>
</template>

<script>
import * as util from "@/utilities/util.js";
import * as fileService from '@/services/file_service'

export default {
  name: "DepositPage",
  components: {},
  data() {
    return {
      isConnected: false,
      tokenContract: null,
      vaultContract: null,
      account: null,

      deposit: {
        userWallet: null,
        amount: null,
      },
      depositList: [],
      counting: false,
      depositType: 'cmty token',
      nftName: '',
      nftDescription: '',
      attributeList: [],
      nftFileName: 'No file selected',
      isMinterUser: false,
      isUriSetterUser: false,

      isViewAsset: false,
      nftMetadata: {},
      util,
      nftUrlImagePreview: null,
    };
  },
  async mounted() {
    this.$watch(
      () => {
        return this.$store.state.isConnected;
      },
      (val) => {
        this.isConnected = val;
      }
    );

    await util.reconnect();
    this.$store.commit("changeConnectionStatus", true);
    this.account = await util.getCoinbase();
    this.$store.commit("changeAccount", this.account);
    this.deposit.userWallet = this.account;

    this.$watch(
      () => {
        return this.depositType;
      },
      (val) => {
        if(val == 'cmty token'){
          this.deposit.userWallet = this.account
        }
      }
    );


    this.tokenContract = await util.tokenContractInstance();
    this.orchestratorContract = await util.OrchestratorContractInstance();
    this.oracleContract = await util.OracleContractInstance();
    this.nftContractInstance = await util.NFTContractInstance();

    if(this.$route.params.token_id){
      const token_id = this.$route.params.token_id
      this.isViewAsset = true
      this.depositType = 'other'

      const tokenOwner = await this.orchestratorContract.methods.NFTUsers(token_id).call()
      this.deposit.userWallet = tokenOwner
      this.deposit.amount  = util.subtractDecimals(await this.nftContractInstance.methods.balanceOf(tokenOwner, token_id).call(), 18)
      const tokenUri = await this.nftContractInstance.methods.uri(token_id).call()
      this.nftMetadata = await (await fetch(tokenUri)).json()
      
      this.nftName = this.nftMetadata.name
      this.nftDescription = this.nftMetadata.description
      this.attributeList = this.nftMetadata.attributes
    }


    this.getDeposits();
    this.startCountdown();

    const MINTER_ROLE = await this.orchestratorContract.methods.MINTER_ROLE().call()
    const URI_SETTER_ROLE = await this.orchestratorContract.methods.MINTER_ROLE().call()
    this.isMinterUser = await this.orchestratorContract.methods.hasRole(MINTER_ROLE, this.account).call()
    this.isUriSetterUser = await this.orchestratorContract.methods.hasRole(URI_SETTER_ROLE, this.account).call()
  },
  methods: {
    async update(){
      let loader = this.$loading.show({});
      try {

        if(this.nftName == null || this.nftName == ''){
          loader.hide()
          util.toast.fire({ icon: "error", title: "Name invalid" });
          return
        }
        if(this.nftDescription == null || this.nftDescription == ''){
          loader.hide()
          util.toast.fire({ icon: "error", title: "Description invalid" });
          return
        }

        const amount = BigInt(util.addDecimals(this.deposit.amount, 18));

        var formData = new FormData();
        var nftFile = document.querySelector('#nftFile');
        formData.append("file", nftFile.files[0]);

        // check selected and extension file
        if(!nftFile.files[0] || nftFile.files[0] == 'null' || nftFile.files[0] == undefined){
          loader.hide()
          util.toast.fire({ icon: "error", title: "No selected file" });
          return
        }
        const allowedExtensions = ['.gif', '.jpg', '.png'];
        const extension = nftFile.files[0].name.substring(nftFile.files[0].name.lastIndexOf(".")).toLowerCase();
        if (!allowedExtensions.includes(extension)) {
          loader.hide()
          util.toast.fire({ icon: "error", title: `Please check the extension of the file you want to upload. Only files with the following extensions can be uploaded: ${allowedExtensions.join(", ")}` });
          return
        }

        const file_upload_response = await fileService.uploadFileToIPFS(formData)

        const fileUri = 'https://ipfs.io/ipfs/'+file_upload_response.data.IpfsHash

        const metadata = {
          pinataContent: {
            name: this.nftName,
            description: this.nftDescription,
            image: fileUri,
            attributes: this.attributeList
          }
        }

        const metadata_upload_response = await fileService.uploadJsonToIPFS(metadata)
        const metadataUri = 'https://ipfs.io/ipfs/'+metadata_upload_response.data.IpfsHash
        console.log(metadataUri)

        await this.nftContractInstance.methods.setTokenURI(5, metadataUri).send({ from: this.account })
        .on("receipt", async (receipt) => {
          loader.hide()
          util.toast.fire({ icon: "success", title: "Update completed!" });
        })
        .on("error", (error) => {
          console.log(error);
          loader.hide()
          util.toast.fire({ icon: "error", title: "please repeat process" });
        });
          
      } catch (error) {
        console.log(error);
        loader.hide()
        util.toast.fire({ icon: "error", title: "please repeat process" });
      }
    },
    addAttribute(){
      this.attributeList.push({})
    },
    removeAttribute(index){
      this.attributeList.splice(index, 1);
    },
    onChangeFileInput(element){
      this.nftFileName = element.target.files[0].name
      this.nftUrlImagePreview = URL.createObjectURL(element.target.files[0])
    },
    async mint(){
      let loader = this.$loading.show({});
      try {
        if (this.deposit.userWallet== null || this.deposit.userWallet== '') {
          loader.hide()
          util.toast.fire({ icon: "error", title: "please enter valid user wallet" });
          return;
        }

        if (!this.deposit.amount || this.deposit.amount == 0) {
          loader.hide()
          util.toast.fire({ icon: "error", title: "please enter valid amount" });
          return;
        }

        if(this.nftName == null || this.nftName == ''){
          loader.hide()
          util.toast.fire({ icon: "error", title: "Name invalid" });
          return
        }
        if(this.nftDescription == null || this.nftDescription == ''){
          loader.hide()
          util.toast.fire({ icon: "error", title: "Description invalid" });
          return
        }


        const amount = BigInt(util.addDecimals(this.deposit.amount, 18));

        var formData = new FormData();
        var nftFile = document.querySelector('#nftFile');
        formData.append("file", nftFile.files[0]);

        // check selected and extension file
        if(!nftFile.files[0] || nftFile.files[0] == 'null' || nftFile.files[0] == undefined){
          loader.hide()
          util.toast.fire({ icon: "error", title: "No selected file" });
          return
        }
        const allowedExtensions = ['.gif', '.jpg', '.png', '.jpeg', '.mp4', '.mp3'];
        const extension = nftFile.files[0].name.substring(nftFile.files[0].name.lastIndexOf(".")).toLowerCase();
        if (!allowedExtensions.includes(extension)) {
          loader.hide()
          util.toast.fire({ icon: "error", title: `Please check the extension of the file you want to upload. Only files with the following extensions can be uploaded: ${allowedExtensions.join(", ")}` });
          return
        }

        

        const file_upload_response = await fileService.uploadFileToIPFS(formData)

        const fileUri = 'https://ipfs.io/ipfs/'+file_upload_response.data.IpfsHash

        const metadata = {
          pinataContent: {
            name: this.nftName,
            description: this.nftDescription,
            image: fileUri,
            attributes: this.attributeList
          }
        }

        const metadata_upload_response = await fileService.uploadJsonToIPFS(metadata)
        const metadataUri = 'https://ipfs.io/ipfs/'+metadata_upload_response.data.IpfsHash
        console.log(metadataUri)

        await this.orchestratorContract.methods.tokenizeRWA(this.deposit.userWallet, amount , metadataUri).send({ from: this.account })
        .on("receipt", async (receipt) => {
          this.getDeposits();
          loader.hide()
          util.toast.fire({ icon: "success", title: "Deposit completed!" });
        })
        .on("error", (error) => {
          console.log(error);
          loader.hide()
          util.toast.fire({ icon: "error", title: "please repeat process" });
        });
          
      } catch (error) {
        console.log(error);
        loader.hide()
        util.toast.fire({ icon: "error", title: "please repeat process" });
      }
    },

    startCountdown: function () {
      this.counting = true;
    },
    onCountdownEnd: function () {
      this.counting = false;
      this.getDeposits();
      setTimeout(() => {
        this.startCountdown();
      }, 100);
    },
    async getDeposits() {
      this.depositList = [];

      const txCount = await this.oracleContract.methods
        .txsCount(this.account)
        .call();

      for (let i = 0; i < txCount; i++) {
        const tx = await this.oracleContract.methods
          .txsPerUser(this.account, i)
          .call();
        if (tx.toCyclos) {
          this.depositList.push({
            amount: util.subtractDecimals(tx.amount, 18),
            finished: tx.finished ? "Processed" : "Pending",
          });
        }
      }
    },

    async approveToken() {
      console.log("Hola 3");

      const balance = util.subtractDecimals(
        await this.tokenContract.methods.balanceOf(this.account).call(),
        18
      );

      if (!this.deposit.amount || this.deposit.amount == 0) {
        util.toast.fire({ icon: "error", title: "please enter valid amount" });
        return;
      }
      if (this.deposit.amount > balance) {
        util.toast.fire({
          icon: "error",
          title: "amount exceeds your balance",
        });
        return;
      }

      let loader = this.$loading.show({});
      const amount = BigInt(util.addDecimals(this.deposit.amount, 18));

      const allowedTokens = BigInt(
        await this.tokenContract.methods
          .allowance(this.account, util.ORCHESTRATOR_ContractAddress)
          .call()
      );
      if (allowedTokens >= amount) {
        loader.hide();
        this.executeDeposit(amount);
        return;
      }

      this.tokenContract.methods
        .approve(util.ORCHESTRATOR_ContractAddress, amount)
        .send({ from: this.account })
        .on("receipt", async (receipt) => {
          util.toast.fire({ icon: "success", title: "tokens approved" });
          this.executeDeposit(amount);
          loader.hide();
        })
        .on("error", (error) => {
          loader.hide();
          console.log(error);
          util.toast.fire({ icon: "error", title: "transaction error" });
        });
    },
    executeDeposit(amount) {
      let loader = this.$loading.show({});
      this.orchestratorContract.methods
        .deposit(amount)
        .send({ from: this.account })
        .on("receipt", async (receipt) => {
          this.getDeposits();
          loader.hide();
          util.toast.fire({ icon: "success", title: "deposit completed" });
        })
        .on("error", (error) => {
          loader.hide();
          console.log(error);
          util.toast.fire({ icon: "error", title: "transaction error" });
        });
    },
  },
};
</script>

<style scoped></style>
